import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import CheckIcon from 'components/material-symbol/icons/Check'
import useStyles from './styles'
import { STEP_COPY } from './step-copy'

const StepPills = ({ steps, activeStep }) => {
  const classes = useStyles()

  return (
    <ol className={classes.pills} aria-label="Registration progress">
      {steps.map((step, index) => {
        const isActive = index === activeStep
        const isDone = index < activeStep
        const label = STEP_COPY[step.name]?.label || step.name

        return (
          <React.Fragment key={step.name}>
            {index > 0 && (
              <li aria-hidden="true" className={classes.pillConnector} />
            )}
            <li
              aria-current={isActive ? 'step' : undefined}
              className={clsx(
                classes.pill,
                isActive && classes.pillActive,
                isDone && classes.pillDone,
              )}
            >
              {isDone ? (
                <CheckIcon aria-hidden="true" />
              ) : (
                <span aria-hidden="true">{index + 1}</span>
              )}
              {label}
            </li>
          </React.Fragment>
        )
      })}
    </ol>
  )
}

StepPills.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string }))
    .isRequired,
  activeStep: PropTypes.number.isRequired,
}

export default StepPills
